/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { Business } from './Business';
import {
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
    BusinessToJSONTyped,
} from './Business';

/**
 * 
 * @export
 * @interface GetBusinessesOwnResponse
 */
export interface GetBusinessesOwnResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetBusinessesOwnResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<Business>}
     * @memberof GetBusinessesOwnResponse
     */
    businesses: Array<Business>;
}

/**
 * Check if a given object implements the GetBusinessesOwnResponse interface.
 */
export function instanceOfGetBusinessesOwnResponse(value: object): value is GetBusinessesOwnResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('businesses' in value) || value['businesses'] === undefined) return false;
    return true;
}

export function GetBusinessesOwnResponseFromJSON(json: any): GetBusinessesOwnResponse {
    return GetBusinessesOwnResponseFromJSONTyped(json, false);
}

export function GetBusinessesOwnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessesOwnResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'businesses': ((json['businesses'] as Array<any>).map(BusinessFromJSON)),
    };
}

export function GetBusinessesOwnResponseToJSON(json: any): GetBusinessesOwnResponse {
    return GetBusinessesOwnResponseToJSONTyped(json, false);
}

export function GetBusinessesOwnResponseToJSONTyped(value?: GetBusinessesOwnResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'businesses': ((value['businesses'] as Array<any>).map(BusinessToJSON)),
    };
}

